var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.5C21.1797 0.5 27 6.3203 27 13.5C27 20.6797 21.1797 26.5 14 26.5C6.8203 26.5 1 20.6797 1 13.5C1 6.3203 6.8203 0.5 14 0.5Z",
    fill: "white",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.5C21.1797 0.5 27 6.3203 27 13.5C27 20.6797 21.1797 26.5 14 26.5C6.8203 26.5 1 20.6797 1 13.5C1 6.3203 6.8203 0.5 14 0.5Z",
    stroke: "url(#paint0_linear_17886_281713)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8572 9.74487C19.042 9.55346 19.1443 9.2971 19.142 9.031C19.1397 8.76491 19.033 8.51036 18.8448 8.32219C18.6566 8.13403 18.4021 8.02729 18.136 8.02498C17.8699 8.02267 17.6135 8.12496 17.4221 8.30983L13.8335 11.8984L10.2449 8.30983C10.1513 8.2129 10.0393 8.13558 9.91545 8.08239C9.79163 8.02921 9.65845 8.00121 9.5237 8.00004C9.38894 7.99887 9.25531 8.02455 9.13058 8.07557C9.00585 8.1266 8.89254 8.20196 8.79725 8.29725C8.70196 8.39254 8.6266 8.50585 8.57557 8.63058C8.52455 8.75531 8.49887 8.88894 8.50004 9.0237C8.50121 9.15845 8.52921 9.29163 8.58239 9.41545C8.63558 9.53927 8.7129 9.65125 8.80983 9.74487L12.3984 13.3335L8.80983 16.9221C8.7129 17.0157 8.63558 17.1277 8.58239 17.2515C8.52921 17.3754 8.50121 17.5085 8.50004 17.6433C8.49887 17.778 8.52455 17.9117 8.57557 18.0364C8.6266 18.1611 8.70196 18.2744 8.79725 18.3697C8.89254 18.465 9.00585 18.5404 9.13058 18.5914C9.25531 18.6424 9.38894 18.6681 9.5237 18.6669C9.65845 18.6658 9.79163 18.6378 9.91545 18.5846C10.0393 18.5314 10.1513 18.4541 10.2449 18.3572L13.8335 14.7685L17.4221 18.3572C17.5157 18.4541 17.6277 18.5314 17.7515 18.5846C17.8754 18.6378 18.0085 18.6658 18.1433 18.6669C18.278 18.6681 18.4117 18.6424 18.5364 18.5914C18.6611 18.5404 18.7744 18.465 18.8697 18.3697C18.965 18.2744 19.0404 18.1611 19.0914 18.0364C19.1424 17.9117 19.1681 17.778 19.1669 17.6433C19.1658 17.5085 19.1378 17.3754 19.0846 17.2515C19.0314 17.1277 18.9541 17.0157 18.8572 16.9221L15.2685 13.3335L18.8572 9.74487Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17886_281713",
    x1: 10.2145,
    y1: 3.19737,
    x2: 24.3846,
    y2: 22.4167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363FBC",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#363FBC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#363FBC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363FBC",
    stopOpacity: 0.43
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.b59ed90589fea63a8bbd95b219588465.svg";
export { ForwardRef as ReactComponent };